export const DEMO_DATA_NEW_USER = [
  {
    firstName: 'Manfred',
    lastName: 'Testheimer',
    tin: '12 123 123 123',
    birthday: '1995-04-15T00:00:00.000Z',
    address: 'Universitätsplatz 12',
    zipCode: '34127',
    city: 'Kassel',
    email: 'mm@fino.digital',
  },
];

export const DEMO_DATA_OLD_USER = [
  {
    firstName: 'Susi',
    lastName: 'Sorglos',
    tin: '23 234 234 234',
    birthday: '1991-03-23T00:00:00.000Z',
    address: 'Hauptstraße 78',
    zipCode: '34326',
    city: 'Buxtehude',
    email: 'susi@email.de',
  },
];



// WEBPACK FOOTER //
// ./src/app/components/owner/demo.js